import React from 'react';
import { useWallet } from '../hooks/useWallet';

const COLORS = { info: 'var(--cyan)', ok: 'var(--gold)', err: 'var(--red)' };

export default function StatusBar() {
  const { status, setStatus } = useWallet();
  if (!status) return null;
  return (
    <div className="card" data-testid="status" role="status" aria-live="polite" style={{ position: 'fixed', left: '50%', bottom: '1.2rem', transform: 'translateX(-50%)', zIndex: 300, width: 'min(760px, 94vw)', padding: '1rem 1.2rem', boxShadow: '0 0 30px rgba(0,0,0,.6)', borderLeftColor: COLORS[status.kind] }}>
      <span className="stat" style={{ color: COLORS[status.kind] }}>{{ info: 'WORKING', ok: 'DONE', err: 'PROBLEM' }[status.kind]}</span>{' '}
      <span>{status.text}</span>
      {status.link && <> · <a href={status.link} target="_blank" rel="noreferrer" style={{ color: 'var(--cyan)' }}>view tx</a></>}
      <button className="action-btn" style={{ marginLeft: '1rem', marginTop: 0, padding: '.2rem .6rem' }} onClick={() => setStatus(null)}>x</button>
    </div>
  );
}
